import { useDirty } from '@client/store/dirty.store';

import type { FormInstance } from 'antd';
import type { FormLayout } from 'antd/es/form/Form';

export const useFormProps = <
  T extends Record<string, unknown> = Record<string, never>,
>(
  loading: boolean,
  formRef: FormInstance,
  options?: T,
) => {
  const { setDirty } = useDirty();

  const props = {
    layout: 'vertical' as FormLayout,
    autoComplete: 'off',
    scrollToFirstError: true,
    onFieldsChange() {
      if (!loading) {
        // Only set dirty if not loading
        setDirty(true);
      }
    },
    form: formRef,
    ...options,
  };

  return { DEFAULT_FORM_PROPS: props };
};
